import React from 'react';
import {Pie} from 'react-chartjs-2';


 
class PieCharts extends React.Component{

  render() {

		let one = this.props.one;
		let two = this.props.two;
		let three = this.props.three;

const data = {
	labels: [
		'Completed',
		'Requested',
		'Pending',

 ],
	datasets: [{
			labels: [
 
 ],
		data:[one, two, three],
		backgroundColor: ["#59ccb3", '#5e98ba', '#e8814a'] ,
		width:100,
		height:400,
 
	}],
 };

    return (
      <div>
              <Pie data={data}    
                   
				   />
      </div>
    );
  }
}

export default PieCharts